import { ChangeEvent, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { useField } from 'formik';

import { PoolNumberTextfield, PoolNumberTextfieldProps } from './pool-number-textfield';

export const PoolFormikNumberTextfield = (
    props: Omit<PoolNumberTextfieldProps, 'onBlur'> & {
        name: string;
        onValueChange?: (value: string | null) => void;
        onBlur?: (value: string | null) => void;
    }
): ReactElement => {
    const { name, helperText, onValueChange, onBlur, ...textFieldProps } = props;
    const [field, meta] = useField({ name });

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        const value = e.target.value ?? null;
        field.onChange({ ...e, target: { ...e.target, value } });
        onValueChange?.(value);
    };

    const handleBlur = (): void => {
        onBlur?.(field.value);
    };

    return (
        <PoolNumberTextfield
            error={meta.touched && !!meta.error}
            helperText={helperText ?? (meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : ' ')}
            {...field}
            onChange={handleChange}
            onBlur={handleBlur}
            {...textFieldProps}
        />
    );
};
